import { appEnv } from "../appEnv";

export const BRAND =
  appEnv.REACT_APP_TUPI_COMPANY_ID || "5fcf83cb29d326670e91bf90";

export const NEO = "600197c5f950233332be931b";
export const NEOCHARGE = "627573bdfa4c1c18db6395f6";
export const MELI_MOOCA = "61562d6855fe750ac2fec423";

export const EFFIX = "610172319e61c5679e296aa7";

export const SHELL =
  appEnv.REACT_APP_SHELL_COMPANY_ID || "6276c8ea2794d940d2cd2426";

export const MOBILIZE = "627437b7fa4c1c18db453cd7";

export const BYD = "66217edeedb2c20009cb244d";
export const BYD_TEST = "65d8ef81d524e60008380924";

export const BRS = "66fadfcdb6c1c7001e6a0eee";

export const VOLTZ = "67a3c7506b3bf8001fb08a07";

export const ION = "67ac9fcec848c5001f0051cc";

export const ANDRADESALES = "67d04a019543aa001fa9398a";

export const CHARGERPRO = "67d1ced5df0c65001fe95cf9";

export const ELESOL = "67d1cf2edf0c65001fe97bca";

export const PLUGBRA = "67daffc293e234001fe6f906";

export const LINKPLUSENERGY = "67ec57099cff68001fb0853d";

export const EVELETROPOSTO = "67c20651e11a26001f333413";

export const CIACHARGE = "661fcf87f45ea3000acf3d6d";

export const ALLIANCEPOWER = "67fed0c4259d67001fd0f3ab";

export const VAEMOB = "67fecbd57f1f23001f973228";

export const TEMP_PHB = "65dcde20ca5442000830540d";

export const TEMP_CIA_CHARGE = "661fcf87f45ea3000acf3d6d";

export const TEMP_ENERGISA = "63dd0b1374a71959c820942c";

export const ECOGREEN = "681249e7771f05001fe8ebe3";

export const AG_POWER = "6821f5bf8b8a3b001f83904a";

export const ZON = "6822014fe43e480020c5868c";

export const FAST_ON = "680b9f8d6c935d001f3fe291";

export const EON = "681e67a53b3a57001f3c07c6";

export const CARREGAEVAI = "68192bce1c2c04001f3ee68c";

export const OLD_MOBILIDADE = "681124cbc5ace6001fbac621";

export const ESQUINA_DO_FUTURO = "684b3df3bdc7f7001f130378";

export const SINAPSE_SOLAR = "681e6a2bf078b0001f5074ea";

export const AG_ELETROVIAS = "6834d77e5e3a91001fd369a5";